(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-form', {
            parent: 'entity',
            url: '/event-form?page&sort&search&categoryId&subCategoryId&agencyId&areaId&workflowStatus&startDate&endDate&searchText',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN','ROLE_EVT_EDIT','ROLE_EVT_READ_ONLY'],
                pageTitle: 'wamasysApp.eventForm.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form/event-forms.html',
                    controller: 'EventFormController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-form-detail', {
            parent: 'entity',
            url: '/event-form/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN','ROLE_EVT_EDIT','ROLE_EVT_READ_ONLY'],
                pageTitle: 'wamasysApp.eventForm.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-form/event-form-detail.html',
                    controller: 'EventFormDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eventForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EventForm', function($stateParams, EventForm) {
                    return EventForm.get({id : $stateParams.id});
                }]
            }
        })
        .state('event-form.new', {
            parent: 'event-form',
            url: '/new',
            data: {
                authorities: ['ROLE_EVT_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form/event-form-dialog.html',
                    controller: 'EventFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateRecord: new Date(),
                                cout: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-form', null, { reload: true });
                }, function() {
                    $state.go('event-form');
                });
            }]
        })
        .state('event-form.edit', {
            parent: 'event-form',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_EVT_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form/event-form-dialog.html',
                    controller: 'EventFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventForm', function(EventForm) {
                            return EventForm.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-form-detail.edit', {
            parent: 'event-form-detail',
            url: '/edit',
            data: {
                authorities: ['ROLE_EVT_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form/event-form-dialog.html',
                    controller: 'EventFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventForm', function(EventForm) {
                            return EventForm.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form-detail', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('event-form-detail', {id: $stateParams.id});
                });
            }]
        })
        .state('event-form.delete', {
            parent: 'event-form',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_EVT_EDIT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-form/event-form-delete-dialog.html',
                    controller: 'EventFormDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EventForm', function(EventForm) {
                            return EventForm.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-form', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
